import React from 'react';

/**
 * CUANDO NO ENCUENTRA EL ALIMENTO (punto 144 del 27-08).
 *
 * Había dos textos distintos para lo mismo: «Sin resultados» en la pantalla de Alimentos y
 * «No se encontraron alimentos» dentro de una comida. Ninguno de los dos decía que se pueda
 * pedir, y los dos suenan a que ha buscado mal.
 *
 * «No lo tenemos» dice de quién es el problema, y le da las dos salidas que existen -- buscar
 * distinto o coger otro -- antes de mencionar pedirlo. Y lo de pedirlo va el último y en
 * gris: que se pueda, pero que no sea lo primero que se le ocurra.
 *
 * VIVE AQUÍ Y NO EN CADA PANTALLA porque el punto dice «igual en los dos sitios»: con el
 * texto escrito dos veces, el día que se cambie uno se quedará el otro. Lo usan
 * `pages/FoodSearchPage` y `components/nutrition/BuildMealModal`.
 *
 * `enAlimentos`: la pantalla de Alimentos lo pasa a true y la tercera línea no se pinta
 * (ficha 32 del parte de Gonzalo, 5-09): «puedes pedirlo desde Alimentos» estando YA en
 * Alimentos mandaba a donde estás, y el enlace de pedir va justo debajo de la lista.
 *
 * `onPedir`: SE PIDE AQUÍ MISMO (Jesús, 9-09). Dentro de la comida esto decía «puedes
 * pedirlo desde Alimentos», que es mandar a alguien a otra pantalla, a repetir la búsqueda
 * y a perder la comida que estaba montando. Su frase: «"Solicitar alimento" dentro de crear
 * dieta». Con `onPedir` el enlace abre el mismo formulario que se abre en Alimentos, sin
 * salir de aquí. Si no llega, se queda la frase de antes: mejor mandar a Alimentos que no
 * decir nada.
 */
const SinResultados = ({ enAlimentos = false, onPedir = null, restantes = null }) => (
    <div className="text-center py-12 px-4" data-testid="sin-resultados">
        <p className="text-sm text-foreground font-medium">No lo tenemos.</p>
        {!enAlimentos && (onPedir ? (
            /* SU MAQUETA DEL 10-09: un botón de verdad, «Solicitar este alimento», y debajo
               el cupo. Antes era media frase gris colgada de «¿Sigue sin estar?», que es
               una nota al pie y no una salida. */
            <div className="mt-4">
                <button type="button" onClick={onPedir} data-testid="pedir-alimento-en-comida"
                    className="w-full max-w-xs mx-auto h-11 rounded-full bg-brand-orange text-white font-bold">
                    Solicitar este alimento
                </button>
                {restantes != null && (
                    <p className="text-xs text-muted-foreground mt-2" data-testid="restantes-en-comida">
                        {restantes === 0
                            ? 'Ya has gastado tus peticiones de esta semana'
                            : restantes === 1
                                ? 'Te queda 1 petición esta semana'
                                : `Te quedan ${restantes} peticiones esta semana`}
                    </p>
                )}
            </div>
        ) : (
            <p className="text-xs text-muted-foreground mt-3">
                ¿Sigue sin estar? Puedes pedirlo desde Alimentos.
            </p>
        ))}
    </div>
);

export default SinResultados;
